const ITEMS = [
  "Certificazioni London Trinity College",
  "Strumenti Classici e Moderni",
  "Canto Lirico e Moderno",
  "Teatro e Musical",
  "Unico corso di Organo in provincia",
  "Quote detraibili nel 730",
  "Accreditamento Regione Emilia-Romagna",
  "Accreditamento Regione Veneto",
  "Percorsi per BES e disabilità",
];

export const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/10 bg-ink-800 py-4 overflow-hidden">
      <div className="flex whitespace-nowrap animate-[marquee_38s_linear_infinite] gap-10">
        {loop.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-10 text-sm text-gray-400">
            <span className="text-gold-500">✦</span>
            {t}
          </span>
        ))}
      </div>
      <style>{`@keyframes marquee { from { transform: translateX(0);} to { transform: translateX(-50%);} }`}</style>
    </div>
  );
};
